import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICarsTypesSlice, IContactUs } from "./types";
import { RequestStatus } from "@app/constants";
import { IRequestFailed } from "@app/types";

const initialState: ICarsTypesSlice = {
  contactUs: {},
};

const slice = createSlice({
  name: "contactUs",
  initialState,
  reducers: {
    contactUs(state, action: PayloadAction<IContactUs>) {
      state.contactUs.status = RequestStatus.RUNNING;
    },
    contactUsSuccess(state, action) {
      state.contactUs.status = RequestStatus.SUCCESS;
      state.contactUs.data = action.payload;
    },
    contactUsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.contactUs.status = RequestStatus.ERROR;
      state.contactUs.error = action.payload;
    },
    //
  },
});

export const { contactUs, contactUsFailed, contactUsSuccess } = slice.actions;

export default slice.reducer;
